import script from "./UsersListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersListView.vue?vue&type=script&setup=true&lang=ts"

import "./UsersListView.vue?vue&type=style&index=0&id=2c996ca8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c996ca8"]])

export default __exports__